import { app } from '@/main';
import flagKeys from '@/constants/flagKeys';
import CoinNetworkPlan from '@/views/Settings/CoinNetworkPlan/CoinNetworkPlan.vue';

import { Route } from '../route.model';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import { getBillingIsBlocked } from '@/utils/billing';

const validateRouteFlag = () => {
  // While billing is hidden the plan screen must not be reachable, not even by
  // typing the URL — the route and the view stay in the code (TWISM-19010). The
  // migrated cohort falls through to the checks below and keeps the screen, in
  // its reduced form (TWISM-19180). The navbar entry follows this guard, so it
  // is also what puts "Coin Network Plan" back in the left menu for them.
  if (getBillingIsBlocked()) return false;

  return (
    app.$store.getters['business/getBusinessInfo'] &&
    app.$store.getters['business/getBusinessInfo'].business &&
    app.$store.getters['business/getBusinessInfo'].business
      .subscriptionStatus !== EBillingStatusTypes.UNAVAILABLE &&
    app.$store.getters['flags/getFlags'].includes(flagKeys.billingModuleV2)
  );
};

const coinNetworkPlan = new Route(
  '/coin-network-plan',
  'coin-network-plan',
  CoinNetworkPlan,
  {
    requiresAuth: true,
    onlyManager: true,
    customFlagValidator: validateRouteFlag,
    isResponsive: flagKeys.responsiveDashboard,
    navbar: {
      name: 'Coin Network Plan',
      icon: 'manage-locations'
    },
    pageView: {
      eventLabel: 'Coin Network Plan'
    }
  }
);

export { coinNetworkPlan };
export default coinNetworkPlan;
